<template>
  <b-container fluid class="p-4">
    <b-row>
      <b-col lg="8" md="8"><h5 class="mb-4">ویرایش رمز
        {{ `${person.name} ${person.last_name}` }}
      </h5></b-col>

      <b-col lg="4" md="4" class="text-left">

        <router-link v-if="isAdmin" :to="{ name: 'User' }">
          <b-button pill variant="primary">لیست کاربران</b-button>
        </router-link>

        <router-link v-else :to="{ name: 'Profile' }">
          <b-button pill variant="primary">بازگشت به پروفایل</b-button>
        </router-link>

      </b-col>

    </b-row>

    <b-col lg="12">
      <b-form @submit.prevent="onSubmit">


        <b-row>

          <b-col v-if="!isAdmin" lg="4" md="4">
            <form-group :validations="$v.form.current_password">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-7"
                    label="رمز عبور کنونی"
                    label-for="input-7"
                >
                  <b-form-input
                      autocomplete="off"
                      id="input-7"
                      type="password"
                      v-model="form.current_password"
                      placeholder="رمز عبور کنونی"
                      :class="{ invalid }"
                  >
                  </b-form-input>

                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>
          <b-col lg="4" md="4">
            <form-group :validations="$v.form.password">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-5"
                    label="رمز عبور جدید"
                    label-for="input-5"
                >
                  <b-form-input
                      autocomplete="off"
                      id="input-5"
                      placeholder="رمز عبور جدید"
                      type="password"
                      v-model="form.password"
                      :class="{ invalid }"
                  >
                  </b-form-input>
                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>
          <b-col lg="4" md="4">
            <form-group :validations="$v.form.password_confirmation">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-9"
                    label="تکرار رمز عبور جدید"
                    label-for="input-9"
                >
                  <b-form-input
                      id="input-9"
                      autocomplete="off"
                      type="password"
                      placeholder="تکرار رمز عبور جدید"
                      v-model="form.password_confirmation"
                      :class="{ invalid }"
                  ></b-form-input>
                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-button type="submit" pill variant="purple" class="w-100 mt-4"
          >تایید
          </b-button
          >
        </b-row>
      </b-form>
    </b-col>

  </b-container>
</template>

<script>
import router from "@/router";
import {mapGetters, mapActions} from "vuex";
import FormGroup from "../../../components/validator/FormGroup";
import FormErrorsManager from "../../../components/validator/FormErrorsManager";
import {required, minLength, sameAs} from "vuelidate/lib/validators";


export default {
  name: "ChangePassword",
  components: {FormGroup, FormErrorsManager},
  data() {
    return {
      form: {}
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "User/isAdmin",
      person: "User/getPerson",
    }),
  },
  validations() {
    if(this.isAdmin){
      return{
        form: {
          password: {
            required, minLength: minLength(8),
          },
          password_confirmation: {
            minLength: minLength(8),
            sameAsPassword: sameAs("password"),
          },
        }
      }
    }
    return{
      form: {
        password: {
          required, minLength: minLength(8),
        },
        password_confirmation: {
          minLength: minLength(8),
          sameAsPassword: sameAs("password"),
        },
        current_password: {
          required, minLength: minLength(8),
        },
      }
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        if (this.isAdmin) {
          this.$store.dispatch("User/updatePerson", this.form);
        } else {
          this.$store.dispatch("User/editProfile", this.form);
        }

      }
    },
  },
  async mounted() {
    const personId = router.currentRoute.params.id;
    await this.$store.dispatch("User/getPerson", personId)
    this.form = {...this.form, ...this.person}
  },
};
</script>

<style scoped>
</style>